<template>
  <div class="StillLife-container">
    <div class="still-life-wrapper scroll-animation" v-scroll-animation>
      <p class="p-still-life">
        大事なのは、山脈や、人や、染色工場や、セミ時雨などからなる外の世界と、きみの中にある広い世界との間に連絡をつけること、
        一歩の距離をおいて並び立つ二つの世界の呼応と調和をはかることだ。
        <br><br>&emsp;たとえば、星を見るとかして。
      </p>
      <p class="p-ikezawa-natsuki"> —————— 池澤夏樹&emsp;『スティル・ライフ』</p>
    </div>
  </div>
</template>

<style scoped>

.StillLife-container {
  display: flex;
  justify-content: center; /* 水平方向中央 */
  align-items: center; /* 垂直方向中央 */
  flex-direction: row;
  height: 100vh;
  width: 100%;
  transform: translateY(-15%);
}

.still-life-wrapper {
  position: relative;
  font-size: 14px;
  font-family: "GenEiKoburiMin";
  display: flex;
  flex-direction: row-reverse;
  color: #493c33;
  width: auto;
}

.p-still-life,
.p-ikezawa-natsuki {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end; /* 下に揃える */
  height: 60vh;
}

.p-still-life {
  text-indent: 1rem;
  -webkit-writing-mode: vertical-rl;
  writing-mode: vertical-rl;
  line-height: 1.5rem;
  margin-left: 2px;
  /* パラグラフ間の横の余白を狭める */
}

.p-ikezawa-natsuki {
  -webkit-writing-mode: vertical-rl;
  writing-mode: vertical-rl;
  align-items: flex-end; 
  margin-left: 2px;
  /* パラグラフ間の横の余白を狭める */
  margin-bottom: 0.5rem;
}

@media screen and (max-width: 1024px) {
  .StillLife-container {
  transform: translateY(-10%);
}
  .still-life-wrapper {
    font-size: 16px;
  }
}

@media screen and (max-width: 570px) {
  .still-life-wrapper {
    font-size: 12px;
  }
}
</style>